<div class="modal-overlay">
  <div class="modal-dialog">
    <div class="modal-content">
      <div>
        <button class="close-btn p-1 rounded-circle border" (click)="closeModal()">×</button>
      </div>
      <h2>Choose how you want to start collecting</h2>

      <div class="option" [ngClass]="doctor_debt_type == 2 ? 'bg-custom-default' : 'bg-custom-consumer'" (click)="selectDebt('consumer')">
        <div class="icon-wrapper">
          <span class="icon"><img class="hw-48" [src]="doctor_debt_type == 2 ? '/assets/images/icons/consumer_grey.svg' : '/assets/images/img/ConsumerIcon.png'" alt=""></span>
        </div>
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center w-100">
            <h3 class="m-0 pt-2 pb-1">Add Consumer Debt</h3>
            <button *ngIf="doctor_debt_type == 2" class="btn btn-light-blue p-2" (click)="showAddDebtCollectionModal(1)">Enable</button>
          </div>
          <p>Recover debt from individual customers</p>
        </div>
      </div>

      <div class="option" [ngClass]="doctor_debt_type == 1 ? 'bg-custom-default' : 'bg-custom-commercial'" (click)="doctor_debt_type != 2 ? selectDebt('commercial') : ($event.stopPropagation())">
        <div class="icon-wrapper">
          <span class="icon"><img class="hw-48" [src]="doctor_debt_type == 1 ? '/assets/images/icons/comercial_grey.svg' : '/assets/images/img/ComercialIcon.png'" alt=""></span>
        </div>
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center w-100">
            <h3 class="m-0 pt-2 pb-1">Add Commercial Debt</h3>
            <button *ngIf="doctor_debt_type == 1" class="btn btn-light-blue p-2" (click)="showAddDebtCollectionModal(2)">Enable</button>
          </div>
          <p>Manage overdue accounts from businesses</p>
        </div>
      </div>
    </div>
  </div>
</div>
